import React from "react"
import PropTypes from "prop-types"
import { Spacer } from "components/views/atoms/Atoms"

const RadioChoiceDeprecated = (props) => {
  const match = props.id === props.currentValue
  const activeColor = match ? "black-80" : props.error ? "old-rose" : "black-80"
  const activeBackground = match ? "bg-carrot-orange-05" : "bg-transparent"

  const border = match ? "b--carrot-orange" : props.error ? "b--invalid-red" : "b--mineral-grey"
  return (
    <div className="flex-grow-1">
      <label className="pointer no-outline-on-focus" tabIndex={1}>
        <div
          id={`radio-choice-${props.name}-${props.id}`}
          className={`fw5 tc lh-solid pv3 ${activeColor} ${activeBackground} ba bw1 ${border} br-pill animate-all`}
        >
          {props.label}
        </div>
        <input
          className="dn mw1"
          readOnly={props.readOnly}
          name={props.name}
          onClick={props.handleInputChange}
          type="radio"
          value={props.id}
          id={props.id}
        />
      </label>
    </div>
  )
}

const FormRadioGroup = (props) => {
  const elements = props.choices.map((choice) => (
    <RadioChoiceDeprecated
      readOnly={props.readOnly}
      error={props.error && !props.currentValue}
      handleInputChange={props.handleInputChange}
      id={choice.id}
      label={choice.label}
      name={props.name}
      key={choice.id}
      currentValue={props.currentValue}
    />
  ))
  const result = elements.reduce(
    (accumulator, currentValue, index) => accumulator.concat(currentValue, <Spacer key={index} width={1} />),
    []
  )
  result.pop()
  return <div className={`flex flex-row justify-between`}>{result}</div>
}

FormRadioGroup.propTypes = {
  choices: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      id: PropTypes.string.isRequired
    })
  ).isRequired,
  currentValue: PropTypes.string,
  readOnly: PropTypes.bool,
  error: PropTypes.bool,
  name: PropTypes.string.isRequired,
  handleInputChange: PropTypes.func,
  onePerRow: PropTypes.bool
}

export { FormRadioGroup }
